module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"summary":"Özet","data":"Veri","report":"Analiz","goals":"Hedefler","documents":"Dokümanlar","audit":"Denetim","My Account":"Hesabım","Admin Panel":"Admin Paneli","Settings":"Ayarlar","Library":"Kütüphane","contact us":"Bize ulaşın","logout":"Çıkış"},"en":{"summary":"Summary","data":"Data","report":"Analysis","goals":"Targets","documents":"Documents","audit":"Audits","My Account":"My Account","Admin Panel":"Admin Panel","Settings":"Settings","Library":"Library","contact us":"Contact us","logout":"Log out"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/TheNavbar.vue
// module id = Prus
// module chunks = 1